import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Space } from 'antd';
import { Radio } from 'ui/styled';
import NumberInput from 'components/NumberInput/NumberInput';
import FilterDropdown from 'components/FilterDropdown';
var ITEMS = [
    { name: '5 miles', value: 5 },
    { name: '10 miles', value: 10 },
    { name: '25 miles', value: 25 },
    { name: '50 miles', value: 50 }
];
export var DEFAULT_TITLE = 'Distance';
var isCustomValue = function (v) {
    for (var i = 0; i < ITEMS.length; i++) {
        if (ITEMS[i].value === v)
            return false;
    }
    return true;
};
var DistanceDropdown = function (_a) {
    var _b = _a.defaultValue, defaultValue = _b === void 0 ? 20 : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, onSave = _a.onSave, _d = _a.dataTest, dataTest = _d === void 0 ? "DistanceDropdown" : _d;
    var _e = useState(''), title = _e[0], setTitle = _e[1];
    var _f = useState(+defaultValue), value = _f[0], setValue = _f[1]; // string->int conversion
    var _g = useState(isCustomValue(+defaultValue) ? +defaultValue : undefined), customValue = _g[0], setCustomValue = _g[1];
    var onChange = function (e) {
        var _a;
        var value = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value;
        setValue(+value);
    };
    var onChangeCustom = function (v) {
        var customValue = +v;
        if (!(Number === null || Number === void 0 ? void 0 : Number.isNaN(customValue))) {
            setCustomValue(customValue);
            setValue(customValue);
        }
    };
    var onResetDistance = function () {
        setValue(20);
        onSave(20);
        setCustomValue(20);
    };
    var onSaveDistance = function () {
        if (value === undefined || +value === 0 || Number.isNaN(+value))
            onResetDistance();
        else {
            setTitle("Distance: ".concat(value, " miles"));
            onSave(value);
        }
    };
    useEffect(function () {
        if (value || customValue) {
            setTitle("".concat(DEFAULT_TITLE, ": ").concat(value || customValue, " miles"));
            return;
        }
        setTitle(DEFAULT_TITLE);
    }, [value, customValue]);
    var content = (_jsx(Radio.Group, { onChange: onChange, value: value, children: _jsxs(Space, { orientation: "vertical", children: [ITEMS.map(function (i) { return (_jsx(Radio, { value: i.value, children: i.name }, i.value)); }), _jsxs(Radio, { value: customValue, children: ["Custom", _jsx(NumberInput, { maxLength: 6, onChange: onChangeCustom, initialValue: customValue, type: "distance" })] })] }) }));
    return (_jsx(FilterDropdown, { disabled: disabled, title: title, content: content, hasDefaultValue: !!defaultValue, onSave: onSaveDistance, onReset: onResetDistance, dataTest: dataTest }));
};
export default DistanceDropdown;
